import './Button.scss';

export default function Button({ text, subtext = null, children = null, onClick, style_, class_, selected = false, ref = null }) {
    const classes = 'black-button ' + (class_ ? class_ : '') + (selected ? ' selected' : '');
    return (
        <div className={classes} onClick={onClick} style={style_} ref={ref}>
            {text}
            {subtext && <div className="button-subtext">{subtext}</div>}
            {children}
        </div>
    );
}